<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import PrettyChoice from '$components/Form/PrettyChoice.svelte';
    import Textarea from '$components/Form/Textarea.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const pestTypeOptions = [
        `Rongeurs : Rats, souris...`,
        `Cafards`,
        `Moustiques`,
        `Punaises de lit`,
        `Frelons et guêpes`,
        `Autre (précisez)`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const establishmentTypeOptions = [
        `Un particulier`,
        `Une entreprise`,
        `Un établissement de santé`,
        `Un hôtel`,
        `Une industrie`,
        `Autre`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const urgencyLevelOptions = [`Urgent`, `Normal`, `Prévention`].map((v) => ({
        label: v,
        value: v,
        key: v,
    }));

    const treatmentTypeOptions = [`Oui`, `Non`].map((v) => ({
        label: v,
        value: v,
        key: v,
    }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.deratisationDesinsectisation.pestType}
        class=""
        let:field
        let:id
        label={`Quel type de nuisibles souhaitez-vous traiter ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={pestTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.deratisationDesinsectisation.establishmentType}
        class=""
        let:field
        let:id
        label={`Quelle est la nature de votre établissement ou espace à traiter ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={establishmentTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.deratisationDesinsectisation.urgencyLevel}
        class=""
        let:field
        let:id
        label={`Quel est le niveau d'urgence de votre besoin ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-3 gap-x-6 gap-y-1"
            choices={urgencyLevelOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.deratisationDesinsectisation.treatmentType}
        class=""
        let:field
        let:id
        label={`Souhaitez-vous un traitement ponctuel ou un contrat de maintenance régulier ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={treatmentTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin : localisation, délais…"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin : localisation, délais…`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
